/* eslint-disable linebreak-style */
import en from 'vuetify/es5/locale/en';

export default {
  label: 'English',
  ...en,
  menu: {
    'external-devices': 'External Devices',
  },
  'external-devices': {
    name: 'External Device',
    plural_name: 'External Devices',
    create: 'New External Device',
    update: 'Update External Device',
    read: 'View External Device',
    delete: 'Delete External Device',
    delete_confirm: 'Are you sure you want to delete this External Device?'
  },
};
